import { Controller } from "stimulus"

export default class extends Controller {
  submit() {
    const form = this.element.querySelector("form")
    if (form && typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else if (form) {
      form.submit()
    }
  }
}
